import { render, staticRenderFns } from "./PlanosExcluidosModal.vue?vue&type=template&id=20ae0cba"
import script from "./PlanosExcluidosModal.vue?vue&type=script&lang=js"
export * from "./PlanosExcluidosModal.vue?vue&type=script&lang=js"
import style0 from "./PlanosExcluidosModal.vue?vue&type=style&index=0&id=20ae0cba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports